<app-poke-search (emitSearch)="search($event)"></app-poke-search>
<section *ngIf="!isLoading" class="slideInUp">
  <ng-template ngFor let-pokemon [ngForOf]="pokemons">
    <a [routerLink]="['details', pokemon.status.id]" class="pokemon" *ngIf="pokemon.status">
      <section class="pokemon-status">
        <h2>
          {{ pokemon.name }}
        </h2>

        <ul>
          <li *ngFor="let value of pokemon.status.types">
            {{ value.type.name }}
          </li>
        </ul>
      </section>

      <section class="pokemon-image" *ngIf="pokemon.status.sprites">
        <img [src]="pokemon.status.sprites.other.dream_world.front_default" [alt]="pokemon.name">
      </section>
    </a>
  </ng-template>

  <div class="paginator">
    <mat-paginator [length]="total"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]"
      aria-label="Select page"
      (page)="onPage($event)">
    </mat-paginator>
  </div>
</section>

<section *ngIf="isLoading" class="errorImage">
  <img src="assets/foraDoAr.png" alt="">
</section>


